import axiosInstance from '../api/axiosConfig';
import { CandidaturaComVaga } from '../../types/candidatura/candidatura';

export const buscarCandidaturasPendentes = async (empresaId: string): Promise<CandidaturaComVaga[]> => {
  try {
    const response = await axiosInstance.get(`/candidaturas/empresa/${empresaId}/pendentes`);
    
    const candidaturas = Array.isArray(response.data) 
      ? response.data 
      : (response.data?.data || response.data?.content || []);
    
    return candidaturas;
  } catch (error: any) {
    console.error('Erro ao buscar candidaturas pendentes:', error);
    
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED') {
      throw new Error('Serviço indisponível. Verifique se o backend está rodando.');
    }
    
    throw new Error('Erro ao carregar candidaturas pendentes.');
  }
};

export const aprovarCandidatura = async (candidaturaId: number): Promise<void> => {
  try {
    await axiosInstance.patch(`/candidaturas/${candidaturaId}/aprovar`, {
      status: 'aprovado'
    });
  } catch (error: any) {
    console.error('Erro ao aprovar candidatura:', error);
    
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED') {
      throw new Error('Serviço indisponível. Não foi possível aprovar a candidatura.');
    }
    
    throw new Error('Erro ao aprovar candidatura.');
  }
};

export const rejeitarCandidatura = async (candidaturaId: number, observacoes?: string): Promise<void> => {
  try {
    await axiosInstance.patch(`/candidaturas/${candidaturaId}/rejeitar`, {
      status: 'rejeitado',
      observacoes
    });
  } catch (error: any) {
    console.error('Erro ao rejeitar candidatura:', error);
    
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED') {
      throw new Error('Serviço indisponível. Não foi possível rejeitar a candidatura.');
    }
    
    throw new Error('Erro ao rejeitar candidatura.');
  }
};

export const buscarCandidatosAprovados = async (empresaId: string): Promise<CandidaturaComVaga[]> => {
  try {
    const response = await axiosInstance.get(`/candidaturas/empresa/${empresaId}/aprovados`, {
      timeout: 5000
    });
        
    const candidaturas = Array.isArray(response.data) 
      ? response.data 
      : (response.data?.data || response.data?.content || []);
    
    return candidaturas;
  } catch (error: any) {
    console.error('Erro ao buscar candidatos aprovados:', error);
    
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED') {
      throw new Error('Serviço indisponível. Verifique se o backend está rodando.');
    }
    
    throw new Error('Erro ao carregar candidatos aprovados.');
  }
};